<template>
  <div>
    <a-select
      v-model="model.counter_id"
      :options="counterList"
      showSearch
      :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
      class="ts-w-full"
    ></a-select>
  </div>
</template>

<script>
export default {
  name: 'counterModal',
  props: ['counter', 'value'],
  data () {
    return {
      model: {
        counter_id: undefined
      }
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    counterList () {
      return this.counter.map(el => ({
        value: el.counter_id,
        label: el.counter_name
      }))
    }
  }
}
</script>
